import { useState, useEffect, useRef } from "react";
import Loading from "../../../Component/Customers/Cards/Loading.jsx";
import NoDataFound from "../../../Component/Customers/Cards/NoDataFound.jsx";
import axios from "axios";
import reachedUser from "../../../Assets/reachedUser.png";
import filterUser from "../../../Assets/filterUser.png";
import workDoneUser from "../../../Assets/workDoneUser.png";
import searchinterfacesymbol from "../../../Assets/search-interface-symbol.png";
import historyUser from "../../../Assets/historyUser.png";
import crossUser from "../../../Assets/crossUser.png";
import assignedTask from "../../../Assets/assignedTask.png";
import comingCrane from "../../../Assets/comingCrane.png";
import checksuccess from "../../../Assets/checksuccess.png";
import ratingStar from "../../../Assets/ratingStar.png";
import dropReason from "../../../Assets/dropReason.png";
import Modal from "../../../Component/CompanyAdmin/Location1/Modal.jsx";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import SignalWifiBadIcon from "@mui/icons-material/SignalWifiBad";
import searchIcon from "../../../Assets/home2/search.svg";

import icon11 from "../../../Assets/crane/icon11.svg";
import icon12 from "../../../Assets/crane/icon12.svg";
import icon13 from "../../../Assets/crane/icon13.svg";
import icon14 from "../../../Assets/crane/icon14.svg";
import icon15 from "../../../Assets/crane/icon15.svg";
import icon16 from "../../../Assets/crane/icon16.svg";
import icon17 from "../../../Assets/crane/icon17.svg";
import starIcon from "../../../Assets/crane/star.svg";
import icon7 from "../../../Assets/crane/icon7.svg";
import navbarRightArrowIcon from "../../../Assets/navbar/right-arrow.svg";
import CraneSideBar from "../../../Component/Customers/slidebar/CraneSideBar.jsx";

import { layerGroup } from "leaflet";

const btns = [
  { name: "Pre Cancelled", id: 1 },
  { name: "Post Cancelled", id: 2 },
];

const CancelledOrders = ({ currentService }) => {
  const [preCancelledOrders, setPreCancelledOrders] = useState([]);
  const [postCancelledOrdrs, setPostCancelledOrders] = useState([]);
  const [data, setData] = useState([]);
  const [filtering, setFiltering] = useState([]);

  const [doneFetching, setDoneFetching] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [searchValue, setSearchValue] = useState("");

  const token = localStorage.getItem("token");
  console.log("token from canceledorder", token);
  const userId = localStorage.getItem("userId");

  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [avg, setAvg] = useState([]);

  const [currentStage, setCurrentStage] = useState([]); // Example stage
  const [isHistoryPage, setIsHistoryPage] = useState(false);
  const [reasonPage, setReasonPage] = useState(false);
  const [currentItem, setCurrentItem] = useState([]);

  const [stages, setStages] = useState([]);

  // const currentService = localStorage.getItem("currentService")

  // const [currentServiceImage, setCurrentServiceImage] = useState(null);
  // useEffect(() => {
  //   console.log("currentservice1234here", currentService);
  //   if (currentService == "crane")
  //     setCurrentServiceImage(
  //       "https://www.ace-cranes.com/images/productimage/168993867620230721.png"
  //     );
  //   if (currentService == "recoveryVan")
  //     setCurrentServiceImage(
  //       "https://www.ace-cranes.com/images/productimage/168993867620230721.png"
  //     );
  // }, [currentService]);

  useEffect(() => {
    setDoneFetching(false);
    getData();
  }, [userId, token, currentService]);

 const getData = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_BACKEND_URL}/api/getCancelledOrdersByCustomers/${userId}/${currentService}/${userId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  if (!response.data?.data?.length) {
    setPreCancelledOrders([]);
    setPostCancelledOrders([]);
    setDoneFetching(true);
    return;
  }

  const addFirstImage = (list) =>
  list.map((item) => {
    const images = item?.images || {};

    const vehicleImage =
      images["Rear Left"] ||
      images["Front Left"] ||
      images["Rear Right"] ||
      images["Front Right"] ||
      null;

    return {
      ...item,
      vehicleImage,
    };
  });


  const sortedPre = addFirstImage(
    [...response.data.data].sort(
      (a, b) => new Date(b.cancelledAt) - new Date(a.cancelledAt)
    )
  );

  const sortedPost = addFirstImage(
    [...(response.data.data2 || [])].sort(
      (a, b) => new Date(b.cancelledAt) - new Date(a.cancelledAt)
    )
  );

  setFiltering(sortedPre);
  setData(sortedPre);
  setPreCancelledOrders(sortedPre);
  setPostCancelledOrders(sortedPost);
  setDoneFetching(true);
};

  useEffect(() => {
    if (data.length > 0 && data.length != currentStage.length) {
      data.map(() => {
        avg.push(0);
      });
    }
  }, [data]);

  const getFilteredData = (filter) => {
    const filteredData = [];

    const now = new Date(); // Current date and time
    const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
    const yesterday = new Date(now.getTime() - oneDay); // Yesterday's date and time
    const weekBefore = new Date(now.getTime() - oneDay * 7);
    const monthBefore = new Date(now.getTime() - oneDay * 30);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const todayDate = formatDate(now);
    const yesterdayDate = formatDate(yesterday);
    const weekBeforeDate = formatDate(weekBefore);
    const monthBeforeDate = formatDate(monthBefore);

    //console.log("todayDate", todayDate)
    //console.log("yesterdayDate", yesterdayDate)

    for (let i = 0; i < filtering.length; i++) {
      let getTime = filtering[i]?.cancelledAt?.split("|");
      let cancelledDate = getTime[0];
      let cancelledTime = getTime[1];
      let cancelledDateTime = new Date(`${cancelledDate} ${cancelledTime}`);

      if (filter === "daily") {
        //console.log("here i am daily")
        if (cancelledDate === todayDate || cancelledDate === yesterdayDate) {
          const timeDifference = now - cancelledDateTime;
          if (timeDifference <= oneDay) {
            //console.log("Match found within last 24 hours:", data[i]);
            filteredData.push(filtering[i]);
          }
        }
      } else if (filter === "weekly") {
        //console.log("here i am weekly")
        if (cancelledDateTime >= weekBefore && cancelledDateTime <= now) {
          //console.log("Match found within last 7 days:", data[i]);
          filteredData.push(filtering[i]);
        }
      } else if (filter === "monthly") {
        if (cancelledDateTime >= monthBefore && cancelledDateTime <= now) {
          //console.log("Match found within last 30 days:", data[i]);
          filteredData.push(filtering[i]);
        }
      } else if (filter === "year") {
        const yearBefore = new Date(now.getTime() - oneDay * 365); // Calculate date one year ago
        if (cancelledDateTime >= yearBefore && cancelledDateTime <= now) {
          //console.log("Match found within last year:", filtering[i]);
          filteredData.push(filtering[i]);
        }
      }
    }
    if (filter === "newest") {
      //console.log("Sorting by newest to oldest");
      //console.log("filtering", filtering[0])
      filtering.sort((a, b) => {
        //console.log("a?.cancelledAt", a?.cancelledAt)
        const dateA = new Date(a?.cancelledAt?.split("|").join(" "));
        const dateB = new Date(b?.cancelledAt?.split("|").join(" "));
        return dateB - dateA; // Descending order
      });
      setData([...filtering]);
    } else if (filter === "oldest") {
      //console.log("Sorting by oldest to newest");
      filtering.sort((a, b) => {
        const dateA = new Date(a?.cancelledAt?.split("|").join(" "));
        const dateB = new Date(b?.cancelledAt?.split("|").join(" "));
        return dateA - dateB; // Ascending order
      });
      setData([...filtering]);
    } else {
      setData(filteredData);
    }
  };

  useEffect(() => {
    //console.log("hello", currentStage);
    if (currentStage[0]) {
      //console.log("helasdfasdflo");
      //console.log("currentStage[0][0] ", currentStage[0])
      setStages([
        {
          label: "Filed",
          img: "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/assignedTask.png",
          date: currentStage[0][0],
        },
        {
          label: "Vendor Assigned",
          img: "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/checksuccess.png",
          date: currentStage[0][1],
        },
        {
          label: "Accepted & Moved",
          img: "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/comingCrane.png",
          date: currentStage[0][2],
        },
        {
          label: "Reached",
          img: "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/reachedUser.png",
          date: currentStage[0][3],
        },
        {
          label: "Work Done",
          img: "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/workDoneUser.png",
          date: currentStage[0][4],
        },
        {
          label: "Cancelled",
          img: "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crossUser.png",
          date: currentStage[0][5],
        },
      ]);
    }
  }, [currentStage[0]]);

  const getStage = (
    systemDate,
    connectedVendorFully,
    vendorMovedTime,
    vendorReachedTime,
    doneWorkingTime,
    cancelledAt
  ) => {
    const stages = [
      systemDate,
      connectedVendorFully,
      vendorMovedTime,
      vendorReachedTime,
      doneWorkingTime,
      cancelledAt,
    ];
    //console.log("stage", stages)
    // return stages.filter((item) => item != "")
    return stages;
  };

  const getStageAndHistory = (item, index) => {
    //console.log("tem?.cancelledAt", item?.cancelledAt)
    //console.log("systemDate, vendorMovedTime, vendorReachedTime, doneWorkingTime, cancelledAt", item?.systemDate, item?.connectedVendorFully ? item?.connectedVendorFullyTime : "hey", item?.customerAcceptedVendor ? item?.customerAcceptedVendorTime : "hey", item?.vendorMoved ? item.vendorMovedTime : "hey", item.vendorReached ? item?.vendorReachedTime : "hey", item.doneWorking ? item?.doneWorkingTime : "hey", item?.cancelledAt)
    let gotStage = getStage(
      item?.systemDate,
      item?.connectedVendorFully ? item?.connectedVendorFullyTime : "",
      item?.vendorMoved ? item.vendorMovedTime : "",
      item.vendorReached ? item?.vendorReachedTime : "",
      item.doneWorking ? item?.doneWorkingTime : "",
      item?.cancelledAt
    );
    //console.log("GOTSTEAG", gotStage)
    setCurrentStage((prevStages) => [gotStage, ...prevStages]);
    setIsHistoryPage(true);
  };

  const getReason = (item, index) => {
    setCurrentItem(item);
    setReasonPage(true);
  };
  // const getStage = (filedCaseFullyTime, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime) => {
  //     console.log("filedCaseFullyTime, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime ||||||||||||", filedCaseFullyTime, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime)
  //     return [filedCaseFullyTime, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime]
  // }
  // const getStageAndHistory = (item, index) => {
  //     let gotStage = getStage(item?.filedCaseFullyTime, item?.customerAcceptedVendorTime, item?.vendorMovedTime, item?.vendorReachedTime, item?.doneWorkingTime)
  //     currentStage.unshift(gotStage)
  //     setIsHistoryPage(true)
  // }

  useEffect(() => {
    return () => setSearchValue("");
  }, []);

  const handleSearch = (inputValue) => {
    const value = inputValue?.toLowerCase() ?? searchValue.toLowerCase();
    setSearchValue(value);
    const newRows = filtering.filter((row) => {
      //console.log('red1231', row)
      const formattedId = String(row.id).padStart(4, "0").toLowerCase();
      const idValue = formattedId.includes(value);
      const vehicleNoValue = (row.reg ?? "").toLowerCase().includes(value);
      const chassisNoValue = (row.accidentFileNo ?? "")
        .toLowerCase()
        .includes(value);
      return idValue || vehicleNoValue || chassisNoValue;
    });
    setData(newRows);
  };

  const handleSelect = (index) => {
    setSelectedIndex(index);
    //console.log("SELECTEDINDOEX", index)
    //console.log("filtering", filtering)

    if (index === 0) {
      setFiltering([...preCancelledOrders]);
      setData([...preCancelledOrders]);
    } else {
      setFiltering([...postCancelledOrdrs]);
      setData([...postCancelledOrdrs]);
    }
  };

  const settingFilter = (filter) => {
    //console.log("filter", filter)
    getFilteredData(filter);
    setOpenFilterModal(false);
  };

  const [hBtn, setHBtn] = useState("Pre Cancelled");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReasonOpen, setSelectedReasonOpen] = useState(null);

  const [isReason, setReason] = useState(false);

  const callButtonClick = (e) => {
    console.log(e);
    setHBtn(e);
    let index = e === "Pre Cancelled" ? 0 : 1;
    console.log(index);
    handleSelect(index);

    console.log(preCancelledOrders);
  };

  const openModalFunction = (reason) => {
    console.log("reaosn", reason);
    setIsModalOpen(true);
    setSelectedReasonOpen(reason);
  };
  const [popupIndex, setPopupIndex] = useState(null);
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setPopupIndex(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const renderPopup = (index, dateStr) => {
    if (popupIndex !== index || !dateStr) return null;
    const [date, time] = dateStr.split("T");
    const formatted = `${date} • ${time?.split(".")[0]}`;
    return (
      <div
        ref={popupRef}
        className="absolute bottom-[50px] left-1/2 -translate-x-1/2 bg-white border border-gray-300 rounded-md shadow-lg px-3 py-1 text-[12px] text-gray-800 z-10 whitespace-nowrap"
      >
        <div className="absolute top-full left-1/2 -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-300 rotate-45 z-[-1]" />
        {formatted}
      </div>
    );
  };

  return (
    <>
      {/* <div className='crane-section'>
                <h6 className="font-[700] text-center font-satoshi text-[61px] leading-[68px] text-[#FFFFFF] pt-[52px] mb-0 pb-[72px]">
                    Crane Service</h6>
                <div style={{ backdropFilter: "blur(20px)" }} className="flex bg-[#FFFFFF4D] max-w-[736px] w-full mx-auto py-[28px] rounded-[66px] pl-[40px] mb-[78px] pr-[28px] items-center justify-between">
                    <input type="text" className='outline-none bg-transparent text-[#FFFFFF] placeholder:text-[#FFFFFF] font-[500] text-[16px] leading-[20px]' placeholder='Search By Service' />
                    <img src={searchIcon} style={{ height: "23px", width: "23px" }} alt="" />

                </div>
            </div> */}
      <div className=" flex md:flex-row flex-col justify-center gap-[30px]">
        {/* <CraneSideBar /> */}
        <div className="max-w-[979px] border-[1px] border-[#E7E4FC] rounded-[12px]">
          <div className="flex gap-[12px] pb-[26px]">
            {btns?.map((e) => {
              return (
                <>
                  <button
                    key={e?.id}
                    onClick={() => callButtonClick(e?.name)}
                    // onClick={() => setHBtn(e?.name)}
                    className={`rounded-[3rem] font-satoshi text-[13px] border-[1px] py-[14px] max-w-[8rem] w-full ${
                      hBtn === e?.name
                        ? "bg-[#21A6E9] text-[#FFFFFF] border-[#E7E4FC] font-[700]"
                        : "bg-[#FFFFFF] text-[#000000] border-[#E7E4FC] font-[400]"
                    }`}
                  >
                    {e?.name}
                  </button>
                </>
              );
            })}
          </div>
          {data.length > 0 && (
            <div>
              {hBtn === "Pre Cancelled" && (
                <div
                  className="h-[500px] overflow-y-auto "
                  style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                >
                  <div style={{ overflow: "hidden" }}>
                    <div className="grid md:grid-cols-2 grid-cols-1 gap-[23px]">
                      {data.map((item, dataIndex) => (
                        <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] py-[40px] md:px-[30px] px-[14px] rounded-[12px]">
                          <ol className="flex items-start gap-[3px] justify-between his-line max-w-[536px] pl-0 mb-0 mx-auto w-full">
                            <li
                              className="w-[60px]"
                              title={item?.systemDate
                                ?.replace("T", " | ")
                                .replace(".000Z", "")}
                            >
                              <div className="flex flex-col items-center gap-[6px]">
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon12.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.systemDate
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi text-[11px] sm:text-[13px] ${
                                    !item?.systemDate
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Filed
                                </p>
                              </div>
                            </li>

                            <li
                              className="w-[60px]"
                              title={item?.customerAcceptedVendorTime
                                ?.replace("T", " | ")
                                .replace(".000Z", "")}
                            >
                              <div className="flex flex-col items-center gap-[6px]">
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon13.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.customerAcceptedVendorTime
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi text-[11px] sm:text-[13px] ${
                                    !item?.customerAcceptedVendorTime
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Vendor Assigned
                                </p>
                              </div>
                            </li>

                            <li
                              className="w-[60px]"
                              title={item?.vendorMovedTime
                                ?.replace("T", " | ")
                                .replace(".000Z", "")}
                            >
                              <div className="flex flex-col items-center gap-[6px]">
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon14.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.vendorMovedTime
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi text-[11px] sm:text-[13px] ${
                                    !item?.vendorMovedTime
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Accepted & Moved
                                </p>
                              </div>
                            </li>

                            <li className="relative w-[60px] cursor-pointer">
                              {renderPopup(
                                `${dataIndex}-3`,
                                item?.vendorReachedTime
                              )}
                              <div
                                className="flex flex-col items-center gap-[6px]"
                                onClick={() => setPopupIndex(`${dataIndex}-3`)}
                              >
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon15.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.vendorReachedTime
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi md:text-[13px] text-[10px] ${
                                    !item?.vendorReachedTime
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Reached
                                </p>
                              </div>
                            </li>

                            <li className="relative w-[60px] cursor-pointer">
                              {renderPopup(
                                `${dataIndex}-4`,
                                item?.doneWorkingTime
                              )}
                              <div
                                className="flex flex-col items-center gap-[6px]"
                                onClick={() => setPopupIndex(`${dataIndex}-4`)}
                              >
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon16.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.doneWorkingTime
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi md:text-[13px] text-[10px] ${
                                    !item?.doneWorkingTime
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Work Done
                                </p>
                              </div>
                            </li>

                            <li className="relative w-[60px] cursor-pointer">
                              {renderPopup(`${dataIndex}-5`, item?.cancelledAt)}
                              <div
                                className="flex flex-col items-center gap-[6px]"
                                onClick={() => setPopupIndex(`${dataIndex}-5`)}
                              >
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon17.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.cancelledAt
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi md:text-[13px] text-[10px] ${
                                    !item?.cancelledAt
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Cancelled
                                </p>
                              </div>
                            </li>
                          </ol>

                          <div className="flex items-center gap-3 mt-[2rem]">
                            <img
                              src={item.vehicleImage}
                              alt="vehicle"
                              className="w-16 h-16 rounded-full object-cover"
                            />
                            <div>
                              <div className="font-semibold my-2 mb-3">
                                {" "}
                                {item?.reg}
                              </div>
                              <div className="text-[15px] font-semibold opacity-60 my-2">
                                {" "}
                                {currentService
                                  .replace(/([A-Z])/g, " $1")
                                  .replace(/^./, (str) =>
                                    str.toUpperCase()
                                  )}{" "}
                                Service
                              </div>

                              <div className="text-sm text-gray-500">
                                {(() => {
                                  const cancelledAt = item?.cancelledAt;
                                  if (!cancelledAt) return "N/A";

                                  const utcDate = new Date(cancelledAt);
                                  const istDate = new Date(
                                    utcDate.getTime() + 5.5 * 60 * 60 * 1000
                                  );

                                  //   const iso = istDate.toISOString(); // Format: "YYYY-MM-DDTHH:MM:SS.sssZ"
                                  //   const date = iso.split("T")[0];
                                  //   const time = iso.split("T")[1].split(".")[0];

                                  //   return `${date} • ${time}`;

                                  const day = String(
                                    istDate.getDate()
                                  ).padStart(2, "0");
                                  const month = String(
                                    istDate.getMonth() + 1
                                  ).padStart(2, "0");
                                  const year = istDate.getFullYear();

                                  let hours = istDate.getHours();
                                  const minutes = String(
                                    istDate.getMinutes()
                                  ).padStart(2, "0");
                                  const seconds = String(
                                    istDate.getSeconds()
                                  ).padStart(2, "0");
                                  const ampm = hours >= 12 ? "PM" : "AM";
                                  hours = hours % 12 || 12;

                                  return `${day}/${month}/${year} • ${hours}:${minutes}:${seconds} ${ampm}`;
                                })()}
                              </div>
                              <div className="text-sm text-gray-600 font-bold my-2">
                                {/* {trip.amount} */}
                                {/* ₹ {item?.charges} /- */}
                                {/* {trip.details ? ` • ${trip.details}` : ''} */}
                              </div>
                            </div>
                          </div>
                          <button
                            onClick={() =>
                              openModalFunction(
                                item?.cancelPreAssignOrderReason
                              )
                            }
                            className="  mt-[1rem] py-[10px] px-[1rem] bg-[#FFFFFF] text-[#21A6E9] border-[1px] w-full rounded-full font-satoshi font-[400] text-sm leading-[33px] outline-none border-[#21A6E9]"
                          >
                            Reason
                          </button>

                          {/* <select name="" id="" className='mt-[30px] pointer-events-none py-[10px] px-[30px] bg-[#FFFFFF] text-[#21A6E9] border-[1px] w-full rounded-full font-satoshi font-[400] text-[24px] leading-[33px] outline-none border-[#21A6E9]'>
                                    <option value="">Reason</option>
                                    <option value="">Reason 1</option>
                                    <option value="">Reason 2</option>
                                    <option value="">Reason 3</option>
                                </select> */}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {hBtn === "Post Cancelled" && (
                <div
                  className="h-[500px] overflow-y-auto "
                  style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                >
                  <div style={{ overflow: "hidden" }}>
                    <div className="grid md:grid-cols-2 grid-cols-1 gap-[23px]">
                      {data.map((item, dataIndex) => (
                        <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] py-[40px] md:px-[30px] px-[14px] rounded-[12px]">
                          <ol className="flex items-start gap-[3px] justify-between his-line max-w-[536px] pl-0 mb-0 mx-auto w-full">
                            <li
                              className="w-[60px]"
                              title={item?.systemDate
                                ?.replace("T", " | ")
                                .replace(".000Z", "")}
                            >
                              <div className="flex flex-col items-center gap-[6px]">
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon12.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.systemDate
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi text-[11px] sm:text-[13px] ${
                                    !item?.systemDate
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Filed
                                </p>
                              </div>
                            </li>

                            <li
                              className="w-[60px]"
                              title={item?.customerAcceptedVendorTime
                                ?.replace("T", " | ")
                                .replace(".000Z", "")}
                            >
                              <div className="flex flex-col items-center gap-[6px]">
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon13.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.customerAcceptedVendorTime
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi text-[11px] sm:text-[13px] ${
                                    !item?.customerAcceptedVendorTime
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Vendor Assigned
                                </p>
                              </div>
                            </li>

                            <li
                              className="w-[60px]"
                              title={item?.vendorMovedTime
                                ?.replace("T", " | ")
                                .replace(".000Z", "")}
                            >
                              <div className="flex flex-col items-center gap-[6px]">
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon14.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.vendorMovedTime
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi text-[11px] sm:text-[13px] ${
                                    !item?.vendorMovedTime
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Accepted & Moved
                                </p>
                              </div>
                            </li>

                            <li className="relative w-[60px] cursor-pointer">
                              {renderPopup(
                                `${dataIndex}-3`,
                                item?.vendorReachedTime
                              )}
                              <div
                                className="flex flex-col items-center gap-[6px]"
                                onClick={() => setPopupIndex(`${dataIndex}-3`)}
                              >
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon15.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.vendorReachedTime
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi md:text-[13px] text-[10px] ${
                                    !item?.vendorReachedTime
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Reached
                                </p>
                              </div>
                            </li>

                            <li className="relative w-[60px] cursor-pointer">
                              {renderPopup(
                                `${dataIndex}-4`,
                                item?.doneWorkingTime
                              )}
                              <div
                                className="flex flex-col items-center gap-[6px]"
                                onClick={() => setPopupIndex(`${dataIndex}-4`)}
                              >
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon16.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.doneWorkingTime
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi md:text-[13px] text-[10px] ${
                                    !item?.doneWorkingTime
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Work Done
                                </p>
                              </div>
                            </li>

                            <li className="relative w-[60px] cursor-pointer">
                              {renderPopup(`${dataIndex}-5`, item?.cancelledAt)}
                              <div
                                className="flex flex-col items-center gap-[6px]"
                                onClick={() => setPopupIndex(`${dataIndex}-5`)}
                              >
                                <img
                                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon17.svg"
                                  className={`h-[38px] w-[38px] ${
                                    !item?.cancelledAt
                                      ? "opacity-100 grayscale"
                                      : ""
                                  }`}
                                  alt=""
                                />
                                <p
                                  className={`m-0 font-[500] font-satoshi md:text-[13px] text-[10px] ${
                                    !item?.cancelledAt
                                      ? "text-gray-400"
                                      : "text-[#21A6E9]"
                                  } text-center`}
                                >
                                  Cancelled
                                </p>
                              </div>
                            </li>
                          </ol>

                          <div className="flex items-center gap-3 mt-[2rem]">
                            <img
                              src={item.vehicleImage}
                              alt="vehicle"
className="w-16 h-16 rounded-full object-cover"                            />
                            <div>
                              <div className="font-semibold my-2 mb-3">
                                {" "}
                                {item?.reg}
                              </div>
                              <div className="text-[15px] font-semibold opacity-60 my-2">
                                {" "}
                                {currentService
                                  .replace(/([A-Z])/g, " $1")
                                  .replace(/^./, (str) =>
                                    str.toUpperCase()
                                  )}{" "}
                                Service
                              </div>

                              <div className="text-sm text-gray-500">
                                {(() => {
                                  const cancelledAt = item?.cancelledAt;
                                  if (!cancelledAt) return "N/A";

                                  const utcDate = new Date(cancelledAt);
                                  const istDate = new Date(
                                    utcDate.getTime() + 5.5 * 60 * 60 * 1000
                                  );

                                  // Format date: dd/mm/yyyy
                                  const day = String(
                                    istDate.getDate()
                                  ).padStart(2, "0");

                                  const month = String(
                                    istDate.getMonth() + 1
                                  ).padStart(2, "0");

                                  const year = istDate.getFullYear();

                                   // Format time: hh:mm:ss AM/PM
                                  let hours = istDate.getHours();
                                  const minutes = String(
                                    istDate.getMinutes()
                                  ).padStart(2, "0");

                                  const seconds = String(
                                    istDate.getSeconds()
                                  ).padStart(2, "0");

                                  const ampm = hours >= 12 ? "PM" : "AM";

                                  hours = hours % 12 || 12;

                                  return `${day}/${month}/${year} • ${hours}:${minutes}:${seconds} ${ampm}`;
                                })()}
                              </div>
                              <div className="text-sm text-gray-600 font-bold my-2">
                                {/* {trip.amount} */}
                                {/* ₹ {item?.charges} /- */}
                                {/* {trip.details ? ` • ${trip.details}` : ''} */}
                              </div>
                            </div>
                          </div>

                          <button
                            onClick={() =>
                              openModalFunction(item.cancelOrderReason)
                            }
                            className="  mt-[1rem] py-[10px] px-[1rem] bg-[#FFFFFF] text-[#21A6E9] border-[1px] w-full rounded-full font-satoshi font-[400] text-sm leading-[33px] outline-none border-[#21A6E9]"
                          >
                            Reason
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {data.length == 0 && (
            // <NoDataFound />
            <div className="text-center text-gray-400 py-10">
              No Details Found
            </div>
          )}
        </div>
      </div>

      <ReasonModal
        isOpen={isModalOpen}
        selectedReasonOpen={selectedReasonOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

const ReasonModal = ({ isOpen, selectedReasonOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
      <div className="bg-white py-[1.6875rem] md:px-[3rem] px-[1.875rem] rounded-[1.875rem] shadow-lg w-[90%] overflow-y-scroll md:w-[44rem]">
        <div className="flex justify-end">
          <img
            onClick={onClose}
            src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg"
            className="h-[1.5rem] w-[1.5rem]"
            alt=""
          />
        </div>
        <div className="flex justify-between items-center mt-[1rem]">
          <h6 className="m-0 font-[500] font-satoshi text-[1.5rem] text-[#000000]">
            Reason
          </h6>
        </div>
        <p className="m-0 font-satoshi font-[500] text-[1rem] text-[#000000] pt-[1.875rem] pb-[0.875rem]">
          Reason To Cancel Order
        </p>
        <p className="rounded-[0.4375rem] py-[1rem] px-[0.625rem] bg-[#F6F6F6] border-[#DEDEE8] border-[1px] font-satoshi font-[500] text-[1rem] text-[#000000]">
          {selectedReasonOpen}
        </p>
        <div className="flex justify-center md:pt-[3.375rem] pt-[1.25rem]">
          <div className="hidden bg-[#21A6E9] flex py-[0.3125rem] rounded-full pr-[0.375rem] pl-[1.625rem]">
            <button
              onClick={onClose}
              className="font-satoshi font-[400] text-[1.125rem] leading-[2.1rem] pr-[3.5rem] text-[#FFFFFF]"
            >
              Submit
            </button>
            <img
              src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelledOrders;
